<script lang="ts">
import { BuilderComponent } from '@/utils/cms';

export const SmallBodyTextRegistration: BuilderComponent = {
  name: 'Small Body Text',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Small Body text here' } },
    },
  ],
  inputs: [
    {
      name: 'underline',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
defineProps<{
  underline?: boolean;
}>();
</script>

<template>
  <p class="text-xs leading-4 lg:text-sm" :class="{ underline: underline }">
    <slot />
  </p>
</template>

<style scoped>
p {
  @apply mb-0;
}
</style>
